import React from "react";

import { Button, Typography } from "clearsense-ui/components";
import ErrorImage from "images/error.png";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-row items-start justify-start w-screen h-screen">
          <div className="w-2/5 m-auto text-center">
            <img src={ErrorImage} alt="Error" className="mx-auto mb-16" />
            <Typography style="h2" className="mb-4">
              Sorry, something went wrong
            </Typography>
            <Typography style="large" className="mb-8">
              Please try reloading the page
            </Typography>
            <Button
              style="primary"
              onClick={() => window.location.reload(false)}
              label="Reload"
              size="large"
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
